/*
import React, { useState } from 'react';
//import './contact.css'; // Assure-toi que ce fichier CSS est importé ici

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) {
      setError('Please fill in all fields');
      return;
    }

    setLoading(true);
    setError('');

    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
      setFormData({ name: '', email: '', message: '' });
    }, 1500);
  };

  return (
    <div className="custom-contact-page">
      <div className="custom-contact-header">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you. Please fill in the form below.</p>
      </div>

      <div className="custom-contact-body">
        <div className="custom-contact-info">
          <div className="custom-info-item">
            <i className="fas fa-map-marker-alt"></i>
            <p>123 Food Street, Cuisine City</p>
          </div>
          <div className="custom-info-item">
            <i className="fas fa-phone"></i>
            <p>+1 (555) 123-4567</p>
          </div>
          <div className="custom-info-item">
            <i className="fas fa-envelope"></i>
            <p>support@fooddelivery.com</p>
          </div>
        </div>

        <div className="custom-contact-form-container">
          {submitted ? (
            <div className="custom-success-message">
              <i className="fas fa-check-circle"></i>
              <h3>Message Sent!</h3>
              <p>We'll get back to you shortly.</p>
              <button onClick={() => setSubmitted(false)} className="custom-btn">Send Another</button>
            </div>
          ) : (
            <form className="custom-contact-form" onSubmit={handleSubmit}>
              {error && <div className="custom-error">{error}</div>}
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
              />
              <textarea
                name="message"
                rows="5"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              <button type="submit" className="custom-btn" disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactPage;*/
/*code updated */
import React, { useState } from 'react';
// import './contact.css'; // Make sure this CSS file is linked in your project

const ContactPage = () => {
  // Form data state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  // Success and loading states
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Handle changes in input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Simulate form submission (Replace this with API call)
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) {
      setError('Please fill in all fields');
      return;
    }

    setLoading(true);
    setError('');

    // Fake delay for submission simulation
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);

      // Reset form after submission
      setFormData({ name: '', email: '', message: '' });

      // Example JSON data format to be sent to backend
      /*
        {
          "name": "John Doe",
          "email": "johndoe@example.com",
          "message": "Hello, I have an issue with my order."
        }
      */
    }, 1500);
  };

  return (
    <div className="custom-contact-page">
      <div className="custom-contact-header">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you. Please fill in the form below.</p>
      </div>

      <div className="custom-contact-body">
        <div className="custom-contact-info">
          {/* Static contact information - can be moved to backend later */}
          <div className="custom-info-item">
            <i className="fas fa-map-marker-alt"></i>
            <p>123 Food Street, Cuisine City</p>
          </div>
          <div className="custom-info-item">
            <i className="fas fa-phone"></i>
            <p>+1 (555) 123-4567</p>
          </div>
          <div className="custom-info-item">
            <i className="fas fa-envelope"></i>
            <p>support@fooddelivery.com</p>
          </div>
        </div>

        <div className="custom-contact-form-container">
          {submitted ? (
            // Success message UI
            <div className="custom-success-message">
              <i className="fas fa-check-circle"></i>
              <h3>Message Sent!</h3>
              <p>We'll get back to you shortly.</p>
              <button onClick={() => setSubmitted(false)} className="custom-btn">Send Another</button>
            </div>
          ) : (
            // Contact form
            <form className="custom-contact-form" onSubmit={handleSubmit}>
              {/* Error message if any field is missing */}
              {error && <div className="custom-error">{error}</div>}

              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
              />
              <textarea
                name="message"
                rows="5"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>

              <button type="submit" className="custom-btn" disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactPage;

